import { anodum } from '@yola/ws-sdk';

const HORIZONTAL_ALIGN_ATTRIBUTE = 'h-align';

/**
 * Retrieves the horizontal alignment of a WS-COLUMNS element.
 *
 * @param {HTMLElement} element - The WS-COLUMNS element to check.
 * @returns {string} The horizontal alignment ('left', 'center', 'right').
 * @throws {Error} If the element is not a WS-COLUMNS.
 */
const getColumnsAlignment = (element) => {
  if (!anodum.isTag(element, 'ws-columns')) {
    throw new Error('getColumnsAlignment: element must be a WS-COLUMNS');
  }

  let alignment = element.getAttribute(HORIZONTAL_ALIGN_ATTRIBUTE);

  if (!alignment) {
    alignment = window.getComputedStyle(element).getPropertyValue('justify-content');
  }

  if (['left', 'center', 'right'].includes(alignment)) {
    return alignment;
  }

  return 'left';
};

export default getColumnsAlignment;
